/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import anime from 'animejs/lib/anime';
import styled from 'styled-components';
import birdAnimation from './img/birdAnimation.svg';
import wall from './img/wall.png';
import boom from './img/boom_anim-02.svg';
import { Container } from 'reactstrap';
import Link from '_Components/Link';
import { withTranslation } from 'react-i18next';
import QButton from '_Components/Buttons/QButton/QButton';

const ReturnMain = styled(Link)`
  padding-top: 1rem;
`;
const Bird = styled.img`
  opacity: 0;
  position: absolute;
  bottom: -${props => props.bottom}px;
  max-width: 200px;
  right: ${props => props.right}px;
`;
const Wall = styled.img`
  opacity: 0;
  bottom: -${props => props.bottom}px;
  position: absolute;
  max-height: 500px;
  right: ${props => props.right}px;
`;
const BoomContainer = styled.div`
  position: absolute;
  bottom: -${props => props.bottom - 110}px;
  max-height: 400px;
  width: 200px;
  right: calc(50% - 201px);
  .boom {
    transform: scale(0);
  }
`;

const Text = styled.div`
  position: absolute;
  top: 100vh;
  left: 0;
  right: 0;
  margin: auto;
`;

class NotFound extends React.Component {
  constructor(props) {
    super(props);
    this.state = { width: 0, height: 0 };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  birdAnimation = () => {
    anime({
      targets: '.bird',
      duration: 3000,
      translateX: [
        {
          value: [-this.state.width / 2 - 200, 'calc(50% + 50px)'],
        },
      ],
      translateY: [
        {
          value: '-=300',
          easing: 'easeInOutSine',
        },
        {
          value: '+=170',
          easing: 'easeInOutSine',
        },
        {
          value: '-=170',
          easing: 'easeInOutSine',
        },
        {
          value: '+=170',
          easing: 'easeInOutSine',
        },
      ],
      delay: 0,
      easing: 'linear',
    });
  };
  wallAnimation = () => {
    anime({
      targets: '.wall',
      duration: 2000,
      translateX: [
        {
          value: [this.state.width + 200, 'calc(50% + 140px)'],
        },
      ],
      delay: 1000,
      easing: 'linear',
    });
  };
  boomAnimation = () => {
    anime({
      targets: '.boom',
      duration: 1000,
      scale: [0, 0],
      delay: 2000,
      complete() {
        anime({
          targets: '.boom',
          duration: 800,
          scale: [0, 1],
          direction: 'alternate',
          delay: 0,
          loop: true,
        });
      },
    });
  };
  textAnimation = () => {
    anime({
      targets: '.errorMessage',
      duration: 1000,
      translateY: [
        {
          value: [0, -this.state.height / 2.1],
          easing: 'easeInOutSine',
        },
      ],
      delay: 2500,
      easing: 'linear',
    });
    anime({
      targets: '.buttonReturn',
      duration: 500,
      scale: [0, 0.8],
      delay: 2500,
      complete() {
        anime({
          targets: '.buttonReturn',
          duration: 800,
          scale: [0.8, 1.2],
          direction: 'alternate',
          delay: 0,
          loop: true,
        });
      },
    });
  };
  opacityElements = () => {
    anime({
      targets: '.bird, .wall',
      duration: 500,
      opacity: [0, 1],
      delay: 0,
    });
  };
  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
    setTimeout(() => {
      this.opacityElements();
      this.birdAnimation();
      this.textAnimation();
      this.wallAnimation();
      this.boomAnimation();
    }, 100);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }
  render() {
    const { t } = this.props;
    return (
      <Container>
        <Bird
          className="bird"
          src={birdAnimation}
          alt="Q°emotion Bird"
          right={this.state.width / 2}
          bottom={this.state.height / 1.7}
        />
        <Wall
          className="wall"
          src={wall}
          alt="Wall"
          right={this.state.width / 2}
          bottom={this.state.height / 1.7}
        />
        <BoomContainer
          id="boom-container"
          right={this.state.width / 2}
          bottom={this.state.height / 1.7}
        >
          <img className="boom" src={boom} alt="boom" />
        </BoomContainer>
        <Text className="mt-5 text-center errorMessage">
          <h1>{t('Oops !')}</h1>
          <p>{t('Sorry, the page you were trying to view does not exist.')}</p>
          <ReturnMain className="buttonReturn" to="main">
            <QButton>{t('button:Return to main page')}</QButton>
          </ReturnMain>
        </Text>
      </Container>
    );
  }
}

export default withTranslation('text')(NotFound);
